import { fetchHelper } from '../../../api/api'
import { businessBasicsActions } from './basicsSlice'

export const updateBasics = userDetails => async dispatch => {
    dispatch(businessBasicsActions.updateBasicsRequest())
    try {
        await fetchHelper.put(`Customer/${userDetails.email}`, userDetails)
        dispatch(businessBasicsActions.updateBasicsRequestSuccess(userDetails))
    } catch (e) {
        dispatch(businessBasicsActions.updateBasicsRequestError(e.message))
    }
}
